import { RanaLoading } from "../../lib/components/rana-loading";
import { storeTenantAndOrganisation } from "../../lib/links-between-sites";
import { SystemStatusPage } from "../../lib/rana-system-status/system-status-page";
import { useIdentityProvidersQuery } from "../queries/query-identity-providers";

import { RanaAuthorisationBackground } from "./rana-authorisation-background";

export interface IdentityProviderChooserProps {
  tenant: string;
  setIdentityProvider: (provider: string) => void;
}

export function IdentityProviderChooser({
  tenant,
  setIdentityProvider,
}: IdentityProviderChooserProps) {
  const identityProvidersQuery = useIdentityProvidersQuery(tenant);

  const identityProviders = identityProvidersQuery?.data?.items ?? [];

  if (identityProvidersQuery.isLoading) {
    return (
      <RanaAuthorisationBackground pageSubTitle={undefined}>
        <RanaLoading size="xl" />
      </RanaAuthorisationBackground>
    );
  }

  if (identityProviders.length === 0) {
    // Clear stored tenant because otherwise some frontends can get in infinite loops.
    storeTenantAndOrganisation("", []);

    return <SystemStatusPage variant="not-found" />;
  }

  return (
    <SystemStatusPage
      variant="login"
      identityProviders={identityProviders}
      redirectToLogin={setIdentityProvider}
    />
  );
}
